
export class BadRequestError extends Error {
  constructor (message, data) {
    super(message)
    this.name = this.constructor.name
    this.errorStatus = 400
    this.errorData = data
  }
}

export class AuthenticationError extends Error {
  constructor (message) {
    super(message)
    this.name = this.constructor.name
    this.errorStatus = 401
  }
}

export class PointShortageError extends Error {
  constructor (message, data) {
    super(message)
    this.name = this.constructor.name
    this.errorStatus = 402
  }
}

export class ForbiddenError extends Error {
  constructor (message) {
    super(message)
    this.name = this.constructor.name
    this.errorStatus = 403
  }
}

export class NotFoundError extends Error {
  constructor (message) {
    super(message)
    this.name = this.constructor.name
    this.errorStatus = 404
  }
}

export class ValidationError extends Error {
  constructor (message, data) {
    super(message)
    this.name = this.constructor.name
    this.errorStatus = 422
    this.errorData = data
  }
}

export class NoInternetError extends Error {
  constructor (message) {
    super(message)
    this.name = this.constructor.name
    this.errorStatus = null
  }
}
